import { css } from '@emotion/css'
import {
  fontSize,
  spacing,
  borderRadius,
  fontWeight,
  breakpoint,
  shorthandHelper,
  mediaQueryHelper,
  colors,
  hexToRgba,
} from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    marginRight: spacing.small,
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.blueZodiac,
    border: `1px solid ${colors.blueZodiac}`,
    borderRadius: borderRadius.extraLarge,
    position: 'relative',

    '&:hover': {
      borderColor: hexToRgba(colors.mischka, 0.4),
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginRight: spacing.default,
    },

    '& > span': {
      color: colors.cornflowerBlue,
      marginLeft: spacing.default,
      fontSize: fontSize.small,
      lineHeight: 1.2,
    },
  }),

  dropdown: css({
    '& > button': {
      fontSize: fontSize.small,
      lineHeight: 1.2,
      fontWeight: fontWeight.semiBold,
      padding: shorthandHelper([spacing.small, spacing.small, spacing.small, spacing.default]),

      [mediaQueryHelper(breakpoint.desktop)]: {
        padding: spacing.small,
      },

      '& > span': {
        maxWidth: 120,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
    },

    '& > ul': {
      minWidth: 240,
      top: `calc(100% + ${spacing.small}px)`,
      right: -spacing.default,
    },
  }),
}

export default styles
